import React from "react";
import Loadergif from "../assets/img/loader.gif";
import "./loader.css";
const Loader = () => {
  return (
    <div className="loader">
      <img
        src="https://cdn.dribbble.com/users/332946/screenshots/3296132/n.gif"
        className="image"
        alt="loader"
      />
    </div>
  );
};

export default Loader;
